// mutation-types.ts:
export enum MutationTypes {
  SET_SYS_INFO = "SET_SYS_INFO",
  CLEAR_SYS_INFO = "CLEAR_SYS_INFO",
  SET_SYS_DB = "SET_SYS_DB",
  SET_VERSION = "SET_VERSION"
}
